// extracted by mini-css-extract-plugin
export default {"container":"MedicalLayout_container__WZ3LC","header":"MedicalLayout_header__QxPZF","logo":"MedicalLayout_logo__WfXVt"};